var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStaging = function SvgStaging(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_711_1823)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_711_1823)",
    filter: "url(#filter0_d_711_1823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7334 16.4C38.7334 15.2955 37.838 14.4 36.7334 14.4H11.6001C10.4955 14.4 9.60007 15.2955 9.60007 16.4V32.6667C9.60007 33.7713 10.4955 34.6667 11.6001 34.6667H36.7334C37.838 34.6667 38.7334 33.7713 38.7334 32.6667V16.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99987 7.74999C1.99987 8.97422 2.99231 9.96666 4.21654 9.96666H37.392C38.002 9.96666 38.585 9.71527 39.0038 9.27171C40.3385 7.85797 39.3362 5.53333 37.392 5.53333H4.21654C2.99231 5.53333 1.99987 6.52576 1.99987 7.74999Z",
    fill: "#E27D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 5.21667C8.33301 3.99244 7.34057 3 6.11634 3C4.89211 3 3.89967 3.99244 3.89967 5.21667V34.9833C3.89967 36.2076 4.89211 37.2 6.11634 37.2C7.34057 37.2 8.33301 36.2076 8.33301 34.9833V5.21667Z",
    fill: "#E27D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.394 11.6363C35.394 10.6824 34.6207 9.90906 33.6668 9.90906C32.7128 9.90906 31.9395 10.6824 31.9395 11.6363V13.9394C31.9395 14.8933 32.7128 15.6666 33.6668 15.6666C34.6207 15.6666 35.394 14.8933 35.394 13.9394V11.6363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8184 11.6363C15.8184 10.6824 15.045 9.90906 14.0911 9.90906C13.1371 9.90906 12.3638 10.6824 12.3638 11.6363V13.9394C12.3638 14.8933 13.1371 15.6666 14.0911 15.6666C15.045 15.6666 15.8184 14.8933 15.8184 13.9394V11.6363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9229 27.102C12.9028 27.102 13.5174 26.6035 13.5174 25.8077V25.8049C13.5174 25.1875 13.1577 24.842 12.2968 24.6607L11.8578 24.5673C11.348 24.4597 11.1413 24.2784 11.1413 23.9896V23.9867C11.1413 23.6384 11.4642 23.426 11.9173 23.426C12.3846 23.4231 12.6876 23.6497 12.7386 23.9669L12.7442 24.0009H13.4438L13.4409 23.9641C13.3899 23.307 12.8264 22.8114 11.9201 22.8114C11.0365 22.8114 10.4078 23.3042 10.4078 24.0349V24.0377C10.4078 24.6466 10.7703 25.0374 11.6058 25.213L12.0447 25.3036C12.5715 25.4169 12.7839 25.5953 12.7839 25.8898V25.8927C12.7839 26.2438 12.4384 26.4874 11.9456 26.4874C11.4273 26.4874 11.062 26.2608 11.028 25.9182L11.0252 25.8898H10.3172L10.32 25.9295C10.371 26.6347 10.9742 27.102 11.9229 27.102ZM15.4714 27H16.202V23.5279H17.4623V22.9134H14.2139V23.5279H15.4714V27ZM17.5868 27H18.3514L18.6913 25.9437H20.2036L20.5463 27H21.3109L19.8609 22.9134H19.0368L17.5868 27ZM19.4248 23.6724H19.4729L20.0223 25.3801H18.8754L19.4248 23.6724ZM23.684 27.102C24.7744 27.102 25.471 26.4251 25.471 25.3687V24.859H23.7747V25.4169H24.7545L24.7517 25.5019C24.7432 26.0824 24.3184 26.4704 23.6954 26.4704C22.9675 26.4704 22.5087 25.8898 22.5087 24.9524V24.9468C22.5087 24.0235 22.959 23.443 23.6727 23.443C24.1966 23.443 24.5705 23.7035 24.7036 24.151L24.7121 24.1793H25.4371L25.4342 24.151C25.2955 23.3523 24.6158 22.8114 23.6727 22.8114C22.5087 22.8114 21.7639 23.6469 21.7639 24.9524V24.9581C21.7639 26.2778 22.5002 27.102 23.684 27.102ZM26.4367 27H27.1673V22.9134H26.4367V27ZM28.2915 27H28.9967V24.185H29.042L31.0499 27H31.6815V22.9134H30.9791V25.7284H30.9338L28.9259 22.9134H28.2915V27ZM34.5559 27.102C35.6462 27.102 36.3429 26.4251 36.3429 25.3687V24.859H34.6465V25.4169H35.6264L35.6235 25.5019C35.615 26.0824 35.1902 26.4704 34.5672 26.4704C33.8394 26.4704 33.3806 25.8898 33.3806 24.9524V24.9468C33.3806 24.0235 33.8309 23.443 34.5445 23.443C35.0685 23.443 35.4423 23.7035 35.5754 24.151L35.5839 24.1793H36.3089L36.3061 24.151C36.1673 23.3523 35.4876 22.8114 34.5445 22.8114C33.3806 22.8114 32.6357 23.6469 32.6357 24.9524V24.9581C32.6357 26.2778 33.3721 27.102 34.5559 27.102Z",
    fill: "#E27D30"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_711_1823",
    x: -1,
    y: 1,
    width: 44,
    height: 42.8485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.441667 0 0 0 0 0.0533681 0 0 0 0 0.0533681 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_711_1823"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_711_1823",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_711_1823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_711_1823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 36.8485,
    fill: "white",
    transform: "translate(2 3)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStaging);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/staging.feb3dd662f7cb7f959d71930fde9ecdc.svg";